class ContentApi {
  static apiContentID (id) {
    const request = new Request(`${process.env.REACT_APP_API_URL}/content/${id}`, {
      method: 'GET',
      headers: new Headers({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + sessionStorage.getItem('token')
      })
    })

    return fetch(request).then(response => response.json()).then(response => {
      return response
    }).catch(error => {
      return error
    })
  }
}

export default ContentApi



// WEBPACK FOOTER //
// ./src/api/ContentApi.js